module.exports = __webpack_public_path__ + "static/3. PRO3 Execution Systems-e8d86b97e1ca0510a593166332180743.png";